import React from 'react';

import { SliderConfig } from '../../CustomBlocks/scale/scaleTypes';
import { SettingsGroup, SettingsRow } from '../slotBookingEditor/settingsUi';
import { TextSetting } from '../quizBlocksEditor/quizEditorUi';

interface SliderEditorProps {
  config: SliderConfig;
  onChange: (patch: Partial<SliderConfig>) => void;
}

type NumericKey = 'min' | 'max' | 'step' | 'defaultValue';

const NUMBER_FIELDS: { key: NumericKey; label: string }[] = [
  { key: 'min', label: 'Minimum' },
  { key: 'max', label: 'Maximum' },
  { key: 'step', label: 'Step' },
  { key: 'defaultValue', label: 'Start position' },
];

const SliderEditor: React.FC<SliderEditorProps> = ({ config, onChange }) => (
  <>
    <SettingsGroup
      title="Range"
      footer="The handle starts at the start position and counts as unanswered until moved."
    >
      {NUMBER_FIELDS.map(({ key, label }) => (
        <SettingsRow key={key} label={label}>
          <input
            type="number"
            className="sb-text-input qe-short-input"
            value={config[key]}
            onChange={(e) => onChange({ [key]: Number(e.target.value) } as Partial<SliderConfig>)}
          />
        </SettingsRow>
      ))}
    </SettingsGroup>

    <SettingsGroup title="Value format" footer="e.g. prefix ₹ for a budget, suffix yrs for age.">
      <SettingsRow label="Prefix and suffix" stacked>
        <div className="qe-inline">
          <input
            type="text"
            className="sb-text-input"
            placeholder="Prefix"
            value={config.prefix}
            onChange={(e) => onChange({ prefix: e.target.value })}
          />
          <input
            type="text"
            className="sb-text-input"
            placeholder="Suffix"
            value={config.suffix}
            onChange={(e) => onChange({ suffix: e.target.value })}
          />
        </div>
      </SettingsRow>
    </SettingsGroup>

    <SettingsGroup title="Labels" footer="Leave empty to show the minimum and maximum values.">
      <TextSetting
        label="Left"
        value={config.lowLabel}
        onChange={(lowLabel) => onChange({ lowLabel })}
      />
      <TextSetting
        label="Right"
        value={config.highLabel}
        onChange={(highLabel) => onChange({ highLabel })}
      />
    </SettingsGroup>
  </>
);

export default SliderEditor;
